import request from '@/config/axios'
export const GetAccountMe = (params) => {
  return request.get({
    baseUrl: 'apm-auth',
    url: '/auth/api/v1/account/me',
    params
  })
}

export const GetComponents = (params) => {
  return request.get({
    baseUrl: 'api-apm',
    url: '/api/v1/component',
    params
  })
}

export const GetLabels = (params) => {
  return request.get({
    baseUrl: 'api-apm',
    url: '/api/v1/label',
    params
  })
}
/******** template start*********** */
//查询所有模板
export const GetAllTemplates = () => {
  return request.get({
    baseUrl: 'api-apm',
    url: '/api/v1/template',
    params:{
      index:0,
      count:1000,
      class: 'custom'
    }
  })
}

//模板同步组件到节点
export const SyncTemplateComponents = (data) => {
  return request.post({
    baseUrl: 'api-apm',
    url: '/api/v1/template/sync',
    data
  })
}
// 模板同步组件进度查询 {id:templateId 模板ID}
export const SyncComponentsStatus = (params) => {
  return request.get({
    baseUrl: 'api-apm',
    url: '/api/v1/template/sync/status',
    params
  })
}

export const UpdateTemplateComponents = (data) => {
  return request.put({
    baseUrl: 'api-apm',
    url: '/api/v1/template/component/list',
    data
  })
}
//最多1000条
export const GetTemplateComponentByIds = (params) => {
  return request.get({
    baseUrl: 'api-apm',
    url: '/api/v1/template/component',
    params
  })
}

export const DeleteTemplateComponent = (id,templateId) => {
  return request.delete({
    baseUrl: 'api-apm',
    url: `/api/v1/template/component?id=${id}&templateId=${templateId}`,
  })
}


export const UpdateTemplateProperties = (data) => {
  return request.put({
    baseUrl: 'api-apm',
    url: '/api/v1/template/property/list',
    data
  })
}
//最多1000条
export const GetTemplatePropertyByIds = (params) => {
  return request.get({
    baseUrl: 'api-apm',
    url: '/api/v1/template/property/byid/list',
    params
  })
}
//模板获取输出参数
export const GetTemplateCalcItems = (params) => {
  return request.get({
    baseUrl: 'api-apm',
    url: '/api/v1/template/property/calcItems',
    params
  })
}
/******** template end********** */
export const GetNodeProperty = (params) => {
  return request.get({
    baseUrl: 'api-apm',
    url: '/api/v2/node/property',
    params
  })
}
//最多1000条
export const GetNodePropertyByIds = (params) => {
  return request.get({
    baseUrl: 'api-apm',
    url: '/api/v1/node/property/byid/list',
    params
  })
}

export const GetNodesByGroup = (params) => {
  return request.get({
    baseUrl: 'api-apm',
    url: '/api/v1/asset/node/bygroup',
    params
  })
}

export const GetNodesByIds = (params) => {
  return request.get({
    baseUrl: 'api-apm',
    url: '/api/v1/asset/node/ids',
    params
  })
}

export const GetNodeList = (params) => {
  return request.get({
    baseUrl: 'api-apm',
    url: '/api/v1/asset/node/list',
    params
  })
}

export const GetGroupByProject = (data) => {
  return request.post({
    baseUrl: 'api-apm',
    url: '/api/v1/asset/group/byproject',
    data
  })
}

export const GetHistRawData = (data) => {
  return request.post({
    baseUrl: 'api-apm',
    url: '/api/v1/hist/raw/data',
    data
  })
}

export const GetLatestData = (data) => {
  return request.post({
    baseUrl: 'api-apm',
    url: '/api/v1/latest/data',
    data
  })
}

//获取报警分类
export const GetAlarmCategory = (params) => {
  return request.get({
    baseUrl: 'api-apm',
    url: '/api/v1/alarmcategory/bygroupornode',
    params
  })
}

export const GetNodeStatus = (params) => {
  return request.get({
    baseUrl: 'api-apm',
    url: '/api/v1/asset/node/status/ids',
    params
  })
}

export const GetNodeCalcItems = (params) => {
  return request.get({
    baseUrl: 'api-apm',
    url: '/api/v1/node/property/calcItems',
    params
  })
}

/*****  alarm-process ***** */
export const GetEventList = (data) => {
  return request.post({
    baseUrl: 'api-apm',
    url: '/alarm-process/api/v1/event/list',
    data
  })
}

export const GetEventTimes = (data) => {
  return request.post({
    baseUrl: 'api-apm',
    url: '/alarm-process/api/v1/event/times',
    data
  })
}

export const getVideoDataSourceList = params => {
  return request.get({
    baseUrl: 'api-apm',
    url: '/api/v1/video/datasource/list',
    params: params
  })
}

export const getVideoChannel = params => {
  return request.get({
    baseUrl: 'api-apm',
    url: '/api/v1/video/channel',
    params: params
  })
}

export const SimplejsonQuery = data => {
  return request.post({
    baseUrl: 'api-apm',
    url: '/api/v1/simplejson/query',
    data
  })  
}

/*****  apm-dashboard-api ***** */
export const DbGetComponentsByNode = (nodeId) => {
  return request.get({
    baseUrl: 'apm-dashboard-api',
    url: '/v3/node/components',
    params:{ nodeId }
  })  
}
export const DbGetCalcs = (nodeId,componentName) => {
  return request.get({
    baseUrl: 'apm-dashboard-api',
    url: '/v3/node/component/calcs',
    params:{
      nodeId,
      componentName
    }
  })  
} 
export const DbSearchNodeList = data => {
  return request.post({
    baseUrl: 'apm-dashboard-api',
    url: '/v3/search/node_list',
    data
  })  
} 
export const DbGetTopo = () => {
  return request.get({
    baseUrl: 'apm-dashboard-api',
    url: '/v3/node/topo'
  })  
}  

export const DbHistRaw = data => {
  return request.post({
    baseUrl: 'apm-dashboard-api',
    url: '/v3/feature/hist/raw',
    data
  })  
}


/*****  apm-dws-api ***** */

export const QueryDataBySql = data => {
  return request.post({
    baseUrl: 'apm-dws',
    url: '/api/v1/dw/data/preview',
    data
  })  
}

export const GetApiGroups = params => {
  return request.get({
    baseUrl: 'apm-dws',
    url: '/api/v1/custom/api/group',
    params
  })  
}

export const GetApiListByGroupId = params => {
  return request.get({
    baseUrl: 'apm-dws',
    url: '/api/v1/custom/api',
    params
  })  
}